import { render, staticRenderFns } from "./TepSolicitudAsignarPadre.vue?vue&type=template&id=7093aa41"
import script from "./TepSolicitudAsignarPadre.vue?vue&type=script&lang=js"
export * from "./TepSolicitudAsignarPadre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports